define(function() {
    var config = {};

    config.magicWord = "tnwConf"; /*universal prefix for events, classes, etc*/
    config.magicWordPre = "tnwConfPre"; /*sync with header.php view*/
    config.magicPrefix = config.magicWord + "-";

    config.baseUrl = window[config.magicWordPre].config.baseUrl;
    config.eventUrl = window[config.magicWordPre].config.eventUrl;
    config.environment = window[config.magicWordPre].config.environment;

    config.eventsPrefix = config.magicPrefix;
    config.events = {
        significantDomChange: config.eventsPrefix + "significantDomChange",
        routerRouteLoaded: config.eventsPrefix + "routerRouteLoaded",

        inputError: config.eventsPrefix + "inputError",
        inputSuccess: config.eventsPrefix + "inputSuccess",

        popoverRequestClose: config.eventsPrefix + "popoverRequestClose",
        popoverOnLoad: config.eventsPrefix + "popoverOnLoad",
        popoverOnBeforeClose: config.eventsPrefix + "popoverOnBeforeClose",

        windowRequestClose: config.eventsPrefix + "windowRequestClose",
        windowOnLoad: config.eventsPrefix + "windowOnLoad",
        windowOnBeforeClose: config.eventsPrefix + "windowOnBeforeClose",

        buttonSwitchToggle: config.eventsPrefix + "buttonSwitchToggle",

        uiInputStepperUp: config.eventsPrefix + "uiInputStepperUp",
        uiInputStepperDown: config.eventsPrefix + "uiInputStepperDown",

        productGroupToggle: config.eventsPrefix + "productGroupToggle",

        formProductsUpdate: config.eventsPrefix + "formProductsUpdate",
        formQuestionsUpdate: config.eventsPrefix + "formQuestionsUpdate",
        formTimetableCategoriesUpdate: config.eventsPrefix + "formTimetableCategoriesUpdate",
        formTimetableTagsUpdate: config.eventsPrefix + "formTimetableTagsUpdate",

        hubspotPropertyUpdate: config.eventsPrefix + "hubspotPropertyUpdate",
    };

    config.prefixes = {
        component: "c_",
        trigger: "trigger_"
    };

    config.component = {};
    config.component.window = {
        canvasClassName: config.prefixes.component + "windowCanvas",
        className: config.prefixes.component + "window"
    };

    return config;
});
